"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectSerializer = void 0;
__exportStar(require("./AggregateEventTypesOut"), exports);
__exportStar(require("./AppPortalAccessIn"), exports);
__exportStar(require("./AppPortalAccessOut"), exports);
__exportStar(require("./AppUsageStatsIn"), exports);
__exportStar(require("./AppUsageStatsOut"), exports);
__exportStar(require("./ApplicationIn"), exports);
__exportStar(require("./ApplicationOut"), exports);
__exportStar(require("./ApplicationPatch"), exports);
__exportStar(require("./ApplicationStats"), exports);
__exportStar(require("./ApplicationTokenExpireIn"), exports);
__exportStar(require("./AttemptStatisticsData"), exports);
__exportStar(require("./AttemptStatisticsResponse"), exports);
__exportStar(require("./BackgroundTaskOut"), exports);
__exportStar(require("./BackgroundTaskStatus"), exports);
__exportStar(require("./BackgroundTaskType"), exports);
__exportStar(require("./BorderRadiusConfig"), exports);
__exportStar(require("./BorderRadiusEnum"), exports);
__exportStar(require("./CompletionChoice"), exports);
__exportStar(require("./CompletionMessage"), exports);
__exportStar(require("./CustomColorPalette"), exports);
__exportStar(require("./CustomThemeOverride"), exports);
__exportStar(require("./DashboardAccessOut"), exports);
__exportStar(require("./Duration"), exports);
__exportStar(require("./EndpointCreatedEvent"), exports);
__exportStar(require("./EndpointCreatedEventData"), exports);
__exportStar(require("./EndpointDeletedEvent"), exports);
__exportStar(require("./EndpointDeletedEventData"), exports);
__exportStar(require("./EndpointDisabledEvent"), exports);
__exportStar(require("./EndpointDisabledEventData"), exports);
__exportStar(require("./EndpointHeadersIn"), exports);
__exportStar(require("./EndpointHeadersOut"), exports);
__exportStar(require("./EndpointHeadersPatchIn"), exports);
__exportStar(require("./EndpointIn"), exports);
__exportStar(require("./EndpointMessageOut"), exports);
__exportStar(require("./EndpointOut"), exports);
__exportStar(require("./EndpointPatch"), exports);
__exportStar(require("./EndpointSecretOut"), exports);
__exportStar(require("./EndpointSecretRotateIn"), exports);
__exportStar(require("./EndpointStats"), exports);
__exportStar(require("./EndpointTransformationIn"), exports);
__exportStar(require("./EndpointTransformationOut"), exports);
__exportStar(require("./EndpointTransformationSimulateIn"), exports);
__exportStar(require("./EndpointTransformationSimulateOut"), exports);
__exportStar(require("./EndpointUpdate"), exports);
__exportStar(require("./EndpointUpdatedEvent"), exports);
__exportStar(require("./EndpointUpdatedEventData"), exports);
__exportStar(require("./EnvironmentIn"), exports);
__exportStar(require("./EnvironmentOut"), exports);
__exportStar(require("./EnvironmentSettingsOut"), exports);
__exportStar(require("./EventExampleIn"), exports);
__exportStar(require("./EventTypeExampleOut"), exports);
__exportStar(require("./EventTypeImportOpenApiIn"), exports);
__exportStar(require("./EventTypeImportOpenApiOut"), exports);
__exportStar(require("./EventTypeImportOpenApiOutData"), exports);
__exportStar(require("./EventTypeIn"), exports);
__exportStar(require("./EventTypeOut"), exports);
__exportStar(require("./EventTypePatch"), exports);
__exportStar(require("./EventTypeSchemaIn"), exports);
__exportStar(require("./EventTypeUpdate"), exports);
__exportStar(require("./ExportEventTypeOut"), exports);
__exportStar(require("./FontSizeConfig"), exports);
__exportStar(require("./GenerateIn"), exports);
__exportStar(require("./GenerateOut"), exports);
__exportStar(require("./HTTPValidationError"), exports);
__exportStar(require("./HttpErrorOut"), exports);
__exportStar(require("./InboundPathParams"), exports);
__exportStar(require("./IntegrationIn"), exports);
__exportStar(require("./IntegrationKeyOut"), exports);
__exportStar(require("./IntegrationOut"), exports);
__exportStar(require("./IntegrationUpdate"), exports);
__exportStar(require("./ListResponseApplicationOut"), exports);
__exportStar(require("./ListResponseApplicationStats"), exports);
__exportStar(require("./ListResponseBackgroundTaskOut"), exports);
__exportStar(require("./ListResponseEndpointMessageOut"), exports);
__exportStar(require("./ListResponseEndpointOut"), exports);
__exportStar(require("./ListResponseEventTypeOut"), exports);
__exportStar(require("./ListResponseIntegrationOut"), exports);
__exportStar(require("./ListResponseMessageAttemptEndpointOut"), exports);
__exportStar(require("./ListResponseMessageAttemptOut"), exports);
__exportStar(require("./ListResponseMessageEndpointOut"), exports);
__exportStar(require("./ListResponseMessageOut"), exports);
__exportStar(require("./ListResponseTemplateOut"), exports);
__exportStar(require("./MessageAttemptEndpointOut"), exports);
__exportStar(require("./MessageAttemptExhaustedEvent"), exports);
__exportStar(require("./MessageAttemptExhaustedEventData"), exports);
__exportStar(require("./MessageAttemptFailedData"), exports);
__exportStar(require("./MessageAttemptFailingEvent"), exports);
__exportStar(require("./MessageAttemptFailingEventData"), exports);
__exportStar(require("./MessageAttemptHeadersOut"), exports);
__exportStar(require("./MessageAttemptOut"), exports);
__exportStar(require("./MessageAttemptRecoveredEvent"), exports);
__exportStar(require("./MessageAttemptRecoveredEventData"), exports);
__exportStar(require("./MessageAttemptTriggerType"), exports);
__exportStar(require("./MessageBroadcastIn"), exports);
__exportStar(require("./MessageBroadcastOut"), exports);
__exportStar(require("./MessageEndpointOut"), exports);
__exportStar(require("./MessageIn"), exports);
__exportStar(require("./MessageOut"), exports);
__exportStar(require("./MessageRawPayloadOut"), exports);
__exportStar(require("./MessageStatus"), exports);
__exportStar(require("./MessageStreamOut"), exports);
__exportStar(require("./OauthPayloadIn"), exports);
__exportStar(require("./OauthPayloadOut"), exports);
__exportStar(require("./OneTimeTokenIn"), exports);
__exportStar(require("./OneTimeTokenOut"), exports);
__exportStar(require("./Ordering"), exports);
__exportStar(require("./RecoverIn"), exports);
__exportStar(require("./RecoverOut"), exports);
__exportStar(require("./ReplayIn"), exports);
__exportStar(require("./ReplayOut"), exports);
__exportStar(require("./RetryScheduleInOut"), exports);
__exportStar(require("./RotatedUrlOut"), exports);
__exportStar(require("./SettingsIn"), exports);
__exportStar(require("./SettingsOut"), exports);
__exportStar(require("./StatisticsPeriod"), exports);
__exportStar(require("./StatusCodeClass"), exports);
__exportStar(require("./TemplateIn"), exports);
__exportStar(require("./TemplateOut"), exports);
__exportStar(require("./TemplatePatch"), exports);
__exportStar(require("./TemplateUpdate"), exports);
__exportStar(require("./TransformationHttpMethod"), exports);
__exportStar(require("./TransformationSimulateIn"), exports);
__exportStar(require("./TransformationSimulateOut"), exports);
__exportStar(require("./TransformationTemplateKind"), exports);
__exportStar(require("./ValidationError"), exports);
const AggregateEventTypesOut_1 = require("./AggregateEventTypesOut");
const AppPortalAccessIn_1 = require("./AppPortalAccessIn");
const AppPortalAccessOut_1 = require("./AppPortalAccessOut");
const AppUsageStatsIn_1 = require("./AppUsageStatsIn");
const AppUsageStatsOut_1 = require("./AppUsageStatsOut");
const ApplicationIn_1 = require("./ApplicationIn");
const ApplicationOut_1 = require("./ApplicationOut");
const ApplicationPatch_1 = require("./ApplicationPatch");
const ApplicationStats_1 = require("./ApplicationStats");
const ApplicationTokenExpireIn_1 = require("./ApplicationTokenExpireIn");
const AttemptStatisticsData_1 = require("./AttemptStatisticsData");
const AttemptStatisticsResponse_1 = require("./AttemptStatisticsResponse");
const BackgroundTaskOut_1 = require("./BackgroundTaskOut");
const BorderRadiusConfig_1 = require("./BorderRadiusConfig");
const CompletionChoice_1 = require("./CompletionChoice");
const CompletionMessage_1 = require("./CompletionMessage");
const CustomColorPalette_1 = require("./CustomColorPalette");
const CustomThemeOverride_1 = require("./CustomThemeOverride");
const DashboardAccessOut_1 = require("./DashboardAccessOut");
const Duration_1 = require("./Duration");
const EndpointCreatedEvent_1 = require("./EndpointCreatedEvent");
const EndpointCreatedEventData_1 = require("./EndpointCreatedEventData");
const EndpointDeletedEvent_1 = require("./EndpointDeletedEvent");
const EndpointDeletedEventData_1 = require("./EndpointDeletedEventData");
const EndpointDisabledEvent_1 = require("./EndpointDisabledEvent");
const EndpointDisabledEventData_1 = require("./EndpointDisabledEventData");
const EndpointHeadersIn_1 = require("./EndpointHeadersIn");
const EndpointHeadersOut_1 = require("./EndpointHeadersOut");
const EndpointHeadersPatchIn_1 = require("./EndpointHeadersPatchIn");
const EndpointIn_1 = require("./EndpointIn");
const EndpointMessageOut_1 = require("./EndpointMessageOut");
const EndpointOut_1 = require("./EndpointOut");
const EndpointPatch_1 = require("./EndpointPatch");
const EndpointSecretOut_1 = require("./EndpointSecretOut");
const EndpointSecretRotateIn_1 = require("./EndpointSecretRotateIn");
const EndpointStats_1 = require("./EndpointStats");
const EndpointTransformationIn_1 = require("./EndpointTransformationIn");
const EndpointTransformationOut_1 = require("./EndpointTransformationOut");
const EndpointTransformationSimulateIn_1 = require("./EndpointTransformationSimulateIn");
const EndpointTransformationSimulateOut_1 = require("./EndpointTransformationSimulateOut");
const EndpointUpdate_1 = require("./EndpointUpdate");
const EndpointUpdatedEvent_1 = require("./EndpointUpdatedEvent");
const EndpointUpdatedEventData_1 = require("./EndpointUpdatedEventData");
const EnvironmentIn_1 = require("./EnvironmentIn");
const EnvironmentOut_1 = require("./EnvironmentOut");
const EnvironmentSettingsOut_1 = require("./EnvironmentSettingsOut");
const EventExampleIn_1 = require("./EventExampleIn");
const EventTypeExampleOut_1 = require("./EventTypeExampleOut");
const EventTypeImportOpenApiIn_1 = require("./EventTypeImportOpenApiIn");
const EventTypeImportOpenApiOut_1 = require("./EventTypeImportOpenApiOut");
const EventTypeImportOpenApiOutData_1 = require("./EventTypeImportOpenApiOutData");
const EventTypeIn_1 = require("./EventTypeIn");
const EventTypeOut_1 = require("./EventTypeOut");
const EventTypePatch_1 = require("./EventTypePatch");
const EventTypeSchemaIn_1 = require("./EventTypeSchemaIn");
const EventTypeUpdate_1 = require("./EventTypeUpdate");
const ExportEventTypeOut_1 = require("./ExportEventTypeOut");
const FontSizeConfig_1 = require("./FontSizeConfig");
const GenerateIn_1 = require("./GenerateIn");
const GenerateOut_1 = require("./GenerateOut");
const HTTPValidationError_1 = require("./HTTPValidationError");
const HttpErrorOut_1 = require("./HttpErrorOut");
const InboundPathParams_1 = require("./InboundPathParams");
const IntegrationIn_1 = require("./IntegrationIn");
const IntegrationKeyOut_1 = require("./IntegrationKeyOut");
const IntegrationOut_1 = require("./IntegrationOut");
const IntegrationUpdate_1 = require("./IntegrationUpdate");
const ListResponseApplicationOut_1 = require("./ListResponseApplicationOut");
const ListResponseApplicationStats_1 = require("./ListResponseApplicationStats");
const ListResponseBackgroundTaskOut_1 = require("./ListResponseBackgroundTaskOut");
const ListResponseEndpointMessageOut_1 = require("./ListResponseEndpointMessageOut");
const ListResponseEndpointOut_1 = require("./ListResponseEndpointOut");
const ListResponseEventTypeOut_1 = require("./ListResponseEventTypeOut");
const ListResponseIntegrationOut_1 = require("./ListResponseIntegrationOut");
const ListResponseMessageAttemptEndpointOut_1 = require("./ListResponseMessageAttemptEndpointOut");
const ListResponseMessageAttemptOut_1 = require("./ListResponseMessageAttemptOut");
const ListResponseMessageEndpointOut_1 = require("./ListResponseMessageEndpointOut");
const ListResponseMessageOut_1 = require("./ListResponseMessageOut");
const ListResponseTemplateOut_1 = require("./ListResponseTemplateOut");
const MessageAttemptEndpointOut_1 = require("./MessageAttemptEndpointOut");
const MessageAttemptExhaustedEvent_1 = require("./MessageAttemptExhaustedEvent");
const MessageAttemptExhaustedEventData_1 = require("./MessageAttemptExhaustedEventData");
const MessageAttemptFailedData_1 = require("./MessageAttemptFailedData");
const MessageAttemptFailingEvent_1 = require("./MessageAttemptFailingEvent");
const MessageAttemptFailingEventData_1 = require("./MessageAttemptFailingEventData");
const MessageAttemptHeadersOut_1 = require("./MessageAttemptHeadersOut");
const MessageAttemptOut_1 = require("./MessageAttemptOut");
const MessageAttemptRecoveredEvent_1 = require("./MessageAttemptRecoveredEvent");
const MessageAttemptRecoveredEventData_1 = require("./MessageAttemptRecoveredEventData");
const MessageBroadcastIn_1 = require("./MessageBroadcastIn");
const MessageBroadcastOut_1 = require("./MessageBroadcastOut");
const MessageEndpointOut_1 = require("./MessageEndpointOut");
const MessageIn_1 = require("./MessageIn");
const MessageOut_1 = require("./MessageOut");
const MessageRawPayloadOut_1 = require("./MessageRawPayloadOut");
const MessageStreamOut_1 = require("./MessageStreamOut");
const OauthPayloadIn_1 = require("./OauthPayloadIn");
const OauthPayloadOut_1 = require("./OauthPayloadOut");
const OneTimeTokenIn_1 = require("./OneTimeTokenIn");
const OneTimeTokenOut_1 = require("./OneTimeTokenOut");
const RecoverIn_1 = require("./RecoverIn");
const RecoverOut_1 = require("./RecoverOut");
const ReplayIn_1 = require("./ReplayIn");
const ReplayOut_1 = require("./ReplayOut");
const RetryScheduleInOut_1 = require("./RetryScheduleInOut");
const RotatedUrlOut_1 = require("./RotatedUrlOut");
const SettingsIn_1 = require("./SettingsIn");
const SettingsOut_1 = require("./SettingsOut");
const TemplateIn_1 = require("./TemplateIn");
const TemplateOut_1 = require("./TemplateOut");
const TemplatePatch_1 = require("./TemplatePatch");
const TemplateUpdate_1 = require("./TemplateUpdate");
const TransformationSimulateIn_1 = require("./TransformationSimulateIn");
const TransformationSimulateOut_1 = require("./TransformationSimulateOut");
const ValidationError_1 = require("./ValidationError");
let primitives = [
    "string",
    "boolean",
    "double",
    "integer",
    "long",
    "float",
    "number",
    "any"
];
const supportedMediaTypes = {
    "application/json": Infinity,
    "application/octet-stream": 0
};
let enumsMap = new Set([
    "BackgroundTaskStatus",
    "BackgroundTaskType",
    "BorderRadiusEnum",
    "EndpointCreatedEventTypeEnum",
    "EndpointDeletedEventTypeEnum",
    "EndpointDisabledEventTypeEnum",
    "EndpointUpdatedEventTypeEnum",
    "MessageAttemptExhaustedEventTypeEnum",
    "MessageAttemptFailingEventTypeEnum",
    "MessageAttemptRecoveredEventTypeEnum",
    "MessageAttemptTriggerType",
    "MessageStatus",
    "Ordering",
    "StatisticsPeriod",
    "StatusCodeClass",
    "TransformationHttpMethod",
    "TransformationTemplateKind",
]);
let typeMap = {
    "AggregateEventTypesOut": AggregateEventTypesOut_1.AggregateEventTypesOut,
    "AppPortalAccessIn": AppPortalAccessIn_1.AppPortalAccessIn,
    "AppPortalAccessOut": AppPortalAccessOut_1.AppPortalAccessOut,
    "AppUsageStatsIn": AppUsageStatsIn_1.AppUsageStatsIn,
    "AppUsageStatsOut": AppUsageStatsOut_1.AppUsageStatsOut,
    "ApplicationIn": ApplicationIn_1.ApplicationIn,
    "ApplicationOut": ApplicationOut_1.ApplicationOut,
    "ApplicationPatch": ApplicationPatch_1.ApplicationPatch,
    "ApplicationStats": ApplicationStats_1.ApplicationStats,
    "ApplicationTokenExpireIn": ApplicationTokenExpireIn_1.ApplicationTokenExpireIn,
    "AttemptStatisticsData": AttemptStatisticsData_1.AttemptStatisticsData,
    "AttemptStatisticsResponse": AttemptStatisticsResponse_1.AttemptStatisticsResponse,
    "BackgroundTaskOut": BackgroundTaskOut_1.BackgroundTaskOut,
    "BorderRadiusConfig": BorderRadiusConfig_1.BorderRadiusConfig,
    "CompletionChoice": CompletionChoice_1.CompletionChoice,
    "CompletionMessage": CompletionMessage_1.CompletionMessage,
    "CustomColorPalette": CustomColorPalette_1.CustomColorPalette,
    "CustomThemeOverride": CustomThemeOverride_1.CustomThemeOverride,
    "DashboardAccessOut": DashboardAccessOut_1.DashboardAccessOut,
    "Duration": Duration_1.Duration,
    "EndpointCreatedEvent": EndpointCreatedEvent_1.EndpointCreatedEvent,
    "EndpointCreatedEventData": EndpointCreatedEventData_1.EndpointCreatedEventData,
    "EndpointDeletedEvent": EndpointDeletedEvent_1.EndpointDeletedEvent,
    "EndpointDeletedEventData": EndpointDeletedEventData_1.EndpointDeletedEventData,
    "EndpointDisabledEvent": EndpointDisabledEvent_1.EndpointDisabledEvent,
    "EndpointDisabledEventData": EndpointDisabledEventData_1.EndpointDisabledEventData,
    "EndpointHeadersIn": EndpointHeadersIn_1.EndpointHeadersIn,
    "EndpointHeadersOut": EndpointHeadersOut_1.EndpointHeadersOut,
    "EndpointHeadersPatchIn": EndpointHeadersPatchIn_1.EndpointHeadersPatchIn,
    "EndpointIn": EndpointIn_1.EndpointIn,
    "EndpointMessageOut": EndpointMessageOut_1.EndpointMessageOut,
    "EndpointOut": EndpointOut_1.EndpointOut,
    "EndpointPatch": EndpointPatch_1.EndpointPatch,
    "EndpointSecretOut": EndpointSecretOut_1.EndpointSecretOut,
    "EndpointSecretRotateIn": EndpointSecretRotateIn_1.EndpointSecretRotateIn,
    "EndpointStats": EndpointStats_1.EndpointStats,
    "EndpointTransformationIn": EndpointTransformationIn_1.EndpointTransformationIn,
    "EndpointTransformationOut": EndpointTransformationOut_1.EndpointTransformationOut,
    "EndpointTransformationSimulateIn": EndpointTransformationSimulateIn_1.EndpointTransformationSimulateIn,
    "EndpointTransformationSimulateOut": EndpointTransformationSimulateOut_1.EndpointTransformationSimulateOut,
    "EndpointUpdate": EndpointUpdate_1.EndpointUpdate,
    "EndpointUpdatedEvent": EndpointUpdatedEvent_1.EndpointUpdatedEvent,
    "EndpointUpdatedEventData": EndpointUpdatedEventData_1.EndpointUpdatedEventData,
    "EnvironmentIn": EnvironmentIn_1.EnvironmentIn,
    "EnvironmentOut": EnvironmentOut_1.EnvironmentOut,
    "EnvironmentSettingsOut": EnvironmentSettingsOut_1.EnvironmentSettingsOut,
    "EventExampleIn": EventExampleIn_1.EventExampleIn,
    "EventTypeExampleOut": EventTypeExampleOut_1.EventTypeExampleOut,
    "EventTypeImportOpenApiIn": EventTypeImportOpenApiIn_1.EventTypeImportOpenApiIn,
    "EventTypeImportOpenApiOut": EventTypeImportOpenApiOut_1.EventTypeImportOpenApiOut,
    "EventTypeImportOpenApiOutData": EventTypeImportOpenApiOutData_1.EventTypeImportOpenApiOutData,
    "EventTypeIn": EventTypeIn_1.EventTypeIn,
    "EventTypeOut": EventTypeOut_1.EventTypeOut,
    "EventTypePatch": EventTypePatch_1.EventTypePatch,
    "EventTypeSchemaIn": EventTypeSchemaIn_1.EventTypeSchemaIn,
    "EventTypeUpdate": EventTypeUpdate_1.EventTypeUpdate,
    "ExportEventTypeOut": ExportEventTypeOut_1.ExportEventTypeOut,
    "FontSizeConfig": FontSizeConfig_1.FontSizeConfig,
    "GenerateIn": GenerateIn_1.GenerateIn,
    "GenerateOut": GenerateOut_1.GenerateOut,
    "HTTPValidationError": HTTPValidationError_1.HTTPValidationError,
    "HttpErrorOut": HttpErrorOut_1.HttpErrorOut,
    "InboundPathParams": InboundPathParams_1.InboundPathParams,
    "IntegrationIn": IntegrationIn_1.IntegrationIn,
    "IntegrationKeyOut": IntegrationKeyOut_1.IntegrationKeyOut,
    "IntegrationOut": IntegrationOut_1.IntegrationOut,
    "IntegrationUpdate": IntegrationUpdate_1.IntegrationUpdate,
    "ListResponseApplicationOut": ListResponseApplicationOut_1.ListResponseApplicationOut,
    "ListResponseApplicationStats": ListResponseApplicationStats_1.ListResponseApplicationStats,
    "ListResponseBackgroundTaskOut": ListResponseBackgroundTaskOut_1.ListResponseBackgroundTaskOut,
    "ListResponseEndpointMessageOut": ListResponseEndpointMessageOut_1.ListResponseEndpointMessageOut,
    "ListResponseEndpointOut": ListResponseEndpointOut_1.ListResponseEndpointOut,
    "ListResponseEventTypeOut": ListResponseEventTypeOut_1.ListResponseEventTypeOut,
    "ListResponseIntegrationOut": ListResponseIntegrationOut_1.ListResponseIntegrationOut,
    "ListResponseMessageAttemptEndpointOut": ListResponseMessageAttemptEndpointOut_1.ListResponseMessageAttemptEndpointOut,
    "ListResponseMessageAttemptOut": ListResponseMessageAttemptOut_1.ListResponseMessageAttemptOut,
    "ListResponseMessageEndpointOut": ListResponseMessageEndpointOut_1.ListResponseMessageEndpointOut,
    "ListResponseMessageOut": ListResponseMessageOut_1.ListResponseMessageOut,
    "ListResponseTemplateOut": ListResponseTemplateOut_1.ListResponseTemplateOut,
    "MessageAttemptEndpointOut": MessageAttemptEndpointOut_1.MessageAttemptEndpointOut,
    "MessageAttemptExhaustedEvent": MessageAttemptExhaustedEvent_1.MessageAttemptExhaustedEvent,
    "MessageAttemptExhaustedEventData": MessageAttemptExhaustedEventData_1.MessageAttemptExhaustedEventData,
    "MessageAttemptFailedData": MessageAttemptFailedData_1.MessageAttemptFailedData,
    "MessageAttemptFailingEvent": MessageAttemptFailingEvent_1.MessageAttemptFailingEvent,
    "MessageAttemptFailingEventData": MessageAttemptFailingEventData_1.MessageAttemptFailingEventData,
    "MessageAttemptHeadersOut": MessageAttemptHeadersOut_1.MessageAttemptHeadersOut,
    "MessageAttemptOut": MessageAttemptOut_1.MessageAttemptOut,
    "MessageAttemptRecoveredEvent": MessageAttemptRecoveredEvent_1.MessageAttemptRecoveredEvent,
    "MessageAttemptRecoveredEventData": MessageAttemptRecoveredEventData_1.MessageAttemptRecoveredEventData,
    "MessageBroadcastIn": MessageBroadcastIn_1.MessageBroadcastIn,
    "MessageBroadcastOut": MessageBroadcastOut_1.MessageBroadcastOut,
    "MessageEndpointOut": MessageEndpointOut_1.MessageEndpointOut,
    "MessageIn": MessageIn_1.MessageIn,
    "MessageOut": MessageOut_1.MessageOut,
    "MessageRawPayloadOut": MessageRawPayloadOut_1.MessageRawPayloadOut,
    "MessageStreamOut": MessageStreamOut_1.MessageStreamOut,
    "OauthPayloadIn": OauthPayloadIn_1.OauthPayloadIn,
    "OauthPayloadOut": OauthPayloadOut_1.OauthPayloadOut,
    "OneTimeTokenIn": OneTimeTokenIn_1.OneTimeTokenIn,
    "OneTimeTokenOut": OneTimeTokenOut_1.OneTimeTokenOut,
    "RecoverIn": RecoverIn_1.RecoverIn,
    "RecoverOut": RecoverOut_1.RecoverOut,
    "ReplayIn": ReplayIn_1.ReplayIn,
    "ReplayOut": ReplayOut_1.ReplayOut,
    "RetryScheduleInOut": RetryScheduleInOut_1.RetryScheduleInOut,
    "RotatedUrlOut": RotatedUrlOut_1.RotatedUrlOut,
    "SettingsIn": SettingsIn_1.SettingsIn,
    "SettingsOut": SettingsOut_1.SettingsOut,
    "TemplateIn": TemplateIn_1.TemplateIn,
    "TemplateOut": TemplateOut_1.TemplateOut,
    "TemplatePatch": TemplatePatch_1.TemplatePatch,
    "TemplateUpdate": TemplateUpdate_1.TemplateUpdate,
    "TransformationSimulateIn": TransformationSimulateIn_1.TransformationSimulateIn,
    "TransformationSimulateOut": TransformationSimulateOut_1.TransformationSimulateOut,
    "ValidationError": ValidationError_1.ValidationError,
};
class ObjectSerializer {
    static findCorrectType(data, expectedType) {
        if (data == undefined) {
            return expectedType;
        }
        else if (primitives.indexOf(expectedType.toLowerCase()) !== -1) {
            return expectedType;
        }
        else if (expectedType === "Date") {
            return expectedType;
        }
        else {
            if (enumsMap.has(expectedType)) {
                return expectedType;
            }
            if (!typeMap[expectedType]) {
                return expectedType;
            }
            let discriminatorProperty = typeMap[expectedType].discriminator;
            if (discriminatorProperty == null) {
                return expectedType;
            }
            else {
                if (data[discriminatorProperty]) {
                    var discriminatorType = data[discriminatorProperty];
                    if (typeMap[discriminatorType]) {
                        return discriminatorType;
                    }
                    else {
                        return expectedType;
                    }
                }
                else {
                    return expectedType;
                }
            }
        }
    }
    static serialize(data, type, format) {
        if (data == undefined) {
            return data;
        }
        else if (primitives.indexOf(type.toLowerCase()) !== -1) {
            return data;
        }
        else if (type.lastIndexOf("Array<", 0) === 0) {
            let subType = type.replace("Array<", "");
            subType = subType.substring(0, subType.length - 1);
            let transformedData = [];
            for (let index in data) {
                let date = data[index];
                transformedData.push(ObjectSerializer.serialize(date, subType, format));
            }
            return transformedData;
        }
        else if (type === "Date") {
            if (format == "date") {
                let month = data.getMonth() + 1;
                month = month < 10 ? "0" + month.toString() : month.toString();
                let day = data.getDate();
                day = day < 10 ? "0" + day.toString() : day.toString();
                return data.getFullYear() + "-" + month + "-" + day;
            }
            else {
                return data.toISOString();
            }
        }
        else {
            if (enumsMap.has(type)) {
                return data;
            }
            if (!typeMap[type]) {
                return data;
            }
            type = this.findCorrectType(data, type);
            let attributeTypes = typeMap[type].getAttributeTypeMap();
            let instance = {};
            for (let index in attributeTypes) {
                let attributeType = attributeTypes[index];
                instance[attributeType.baseName] = ObjectSerializer.serialize(data[attributeType.name], attributeType.type, attributeType.format);
            }
            return instance;
        }
    }
    static deserialize(data, type, format) {
        type = ObjectSerializer.findCorrectType(data, type);
        if (data == undefined) {
            return data;
        }
        else if (primitives.indexOf(type.toLowerCase()) !== -1) {
            return data;
        }
        else if (type.lastIndexOf("Array<", 0) === 0) {
            let subType = type.replace("Array<", "");
            subType = subType.substring(0, subType.length - 1);
            let transformedData = [];
            for (let index in data) {
                let date = data[index];
                transformedData.push(ObjectSerializer.deserialize(date, subType, format));
            }
            return transformedData;
        }
        else if (type === "Date") {
            return new Date(data);
        }
        else {
            if (enumsMap.has(type)) {
                return data;
            }
            if (!typeMap[type]) {
                return data;
            }
            let instance = new typeMap[type]();
            let attributeTypes = typeMap[type].getAttributeTypeMap();
            for (let index in attributeTypes) {
                let attributeType = attributeTypes[index];
                instance[attributeType.name] = ObjectSerializer.deserialize(data[attributeType.baseName], attributeType.type, attributeType.format);
            }
            return instance;
        }
    }
    static normalizeMediaType(mediaType) {
        if (mediaType === undefined) {
            return undefined;
        }
        return mediaType.split(";")[0].trim().toLowerCase();
    }
    static getPreferredMediaType(mediaTypes) {
        if (!mediaTypes) {
            return "application/json";
        }
        const normalMediaTypes = mediaTypes.map(this.normalizeMediaType);
        let selectedMediaType = undefined;
        let selectedRank = -Infinity;
        for (const mediaType of normalMediaTypes) {
            if (supportedMediaTypes[mediaType] > selectedRank) {
                selectedMediaType = mediaType;
                selectedRank = supportedMediaTypes[mediaType];
            }
        }
        if (selectedMediaType === undefined) {
            throw new Error("None of the given media types are supported: " + mediaTypes.join(", "));
        }
        return selectedMediaType;
    }
    static stringify(data, mediaType) {
        if (mediaType === "application/json") {
            return JSON.stringify(data);
        }
        throw new Error("The mediaType " + mediaType + " is not supported by ObjectSerializer.stringify.");
    }
    static parse(rawData, mediaType) {
        if (mediaType === undefined) {
            throw new Error("Cannot parse content. No Content-Type defined.");
        }
        if (mediaType === "application/json") {
            return JSON.parse(rawData);
        }
        throw new Error("The mediaType " + mediaType + " is not supported by ObjectSerializer.parse.");
    }
}
exports.ObjectSerializer = ObjectSerializer;
//# sourceMappingURL=ObjectSerializer.js.map